import React, { useState, useEffect, useCallback, useMemo, createContext, useContext } from "react";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [afiliatToken, setAfiliatToken] = useState(sessionStorage.getItem("afiliatToken"));
  const [afiliatData, setAfiliatData] = useState(JSON.parse(sessionStorage.getItem("afiliatData") || "null"));
  const [adminToken, setAdminToken] = useState(sessionStorage.getItem("adminToken"));
  const [userRole, setUserRole] = useState(sessionStorage.getItem("userRole"));

  const loginAfiliat = useCallback((token, data) => {
    sessionStorage.setItem("afiliatToken", token);
    sessionStorage.setItem("afiliatData", JSON.stringify(data));
    sessionStorage.setItem("userRole", "afiliat");
    setAfiliatToken(token);
    setAfiliatData(data);
    setUserRole("afiliat");
  }, [setAfiliatToken, setAfiliatData, setUserRole]);

  const logoutAfiliat = useCallback(() => {
    sessionStorage.removeItem("afiliatToken");
    sessionStorage.removeItem("afiliatData");
    sessionStorage.removeItem("userRole");
    setAfiliatToken(null);
    setAfiliatData(null);
    setUserRole(null);
  }, [setAfiliatToken, setAfiliatData, setUserRole]);

  const loginAdmin = useCallback((token, role = "admin") => {
    sessionStorage.setItem("adminToken", token);
    sessionStorage.setItem("userRole", role);
    setAdminToken(token);
    setUserRole(role);
  }, [setAdminToken, setUserRole]);

  const logoutAdmin = useCallback(() => {
    sessionStorage.removeItem("adminToken");
    sessionStorage.removeItem("userRole");
    setAdminToken(null);
    setUserRole(null);
  }, [setAdminToken, setUserRole]);

  const value = useMemo(() => ({
    afiliatToken, afiliatData, adminToken, userRole, loginAfiliat, logoutAfiliat, loginAdmin, logoutAdmin
  }), [afiliatToken, afiliatData, adminToken, userRole, loginAfiliat, logoutAfiliat, loginAdmin, logoutAdmin]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
